export default __webpack_public_path__ + "d8ed37efc70dcd808bda80a47cda5577.svg";